import React from "react"
import hand_dollar_svg from "../../images/hand-dollar.svg"
import family_health_svg from "../../images/family-health.svg"
import phone_eco_svg from "../../images/phone-eco.svg"
import co2_bubble_svg from "../../images/co2-bubble.svg"
import ContentDataItem from "./ContentDataItem"
import { StyledBigHeaderH2 } from "../Typography"
import { Col, Container, Row, Visible } from "react-grid-system"
import { Fade } from "react-reveal"
import styled from "styled-components"
import { breakpoint } from "../../utils/breakpoint"

const StyledSection = styled.section`
  background-color: #ebebec;
  padding-top: 56px;
  padding-bottom: 56px;
  overflow-x: hidden;
`
const StyledColItemWrapper = styled.div`
  margin-bottom: 5%;

  ${breakpoint.sm} {
    margin-bottom: 6%;
  }

  ${breakpoint.md} {
    margin-bottom: 4%;
  }
  ${breakpoint.lg} {
    margin-bottom: 0;
  }
`

const StyledSecondContainerWrapper = styled.div`
  width: 100%;
  margin-top: 0;

  ${breakpoint.lg} {
    margin-top: 20px;
  }
`

const ImpactAcrossPortfolioSection = () => {
  return (
    <StyledSection>
      <Container fluid xs sm md>
        <Fade ssrReveal>
          <Visible xs sm md>
            <StyledBigHeaderH2 style={{ marginBottom: "60px" }}>
              Impact Across Our Portfolio
            </StyledBigHeaderH2>
          </Visible>
          <Visible lg xl xxl>
            <StyledBigHeaderH2 style={{ marginBottom: "60px" }}>
              Impact Across <br />
              Our Portfolio
            </StyledBigHeaderH2>
          </Visible>
        </Fade>
        <Row>
          <Col xs={12} lg={6}>
            <Fade ssrReveal left>
              <StyledColItemWrapper>
                <ContentDataItem
                  title="Financial Inclusion"
                  iconSrc={hand_dollar_svg}
                  iconDescription="financial inclusion"
                  iconText="460,000"
                >
                  <div>
                    people and microenterprises gained access to credit and
                    financial services
                  </div>
                </ContentDataItem>
              </StyledColItemWrapper>
            </Fade>
          </Col>
          <Col xs={12} lg={6}>
            <Fade ssrReveal right>
              <StyledColItemWrapper>
                <ContentDataItem
                  title="Inclusive Agriculture"
                  iconSrc={phone_eco_svg}
                  iconDescription="inclusive agriculture"
                  iconText="1.5M"
                >
                  <div>
                    smallholder farmers globally gained access to customised
                    farming advice and information
                  </div>
                </ContentDataItem>
              </StyledColItemWrapper>
            </Fade>
          </Col>
        </Row>
      </Container>
      <StyledSecondContainerWrapper>
        <Container fluid xs sm md>
          <Row>
            <Col xs={12} lg={6}>
              <Fade ssrReveal left delay={300}>
                <StyledColItemWrapper>
                  <ContentDataItem
                    title="Environmental Impact"
                    iconSrc={co2_bubble_svg}
                    iconDescription="Environmental Impact"
                    iconText="1.1M"
                  >
                    <div>
                      metric tons of CO<sub>2</sub> emissions avoided
                    </div>
                  </ContentDataItem>
                </StyledColItemWrapper>
              </Fade>
            </Col>
            <Col xs={12} lg={6}>
              <Fade ssrReveal right delay={300}>
                <ContentDataItem
                  title="Health and Prevention"
                  iconSrc={family_health_svg}
                  iconDescription="health and prevention"
                  iconText="129,000"
                >
                  <div>
                    people received oral-health treatment along with prevention
                  </div>
                </ContentDataItem>
              </Fade>
            </Col>
          </Row>
        </Container>
      </StyledSecondContainerWrapper>
    </StyledSection>
  )
}

export default ImpactAcrossPortfolioSection
